import { render } from "./ProductCategoryFormView.vue?vue&type=template&id=b7f1e804"
import script from "./ProductCategoryFormView.vue?vue&type=script&lang=js"
export * from "./ProductCategoryFormView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__